import React, { lazy } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function TypographyPage() {
  return <div className="min-h-screen bg-[#d9e2e8] p-2 md:p-4 font-sans selection:bg-accent selection:text-white" data-id="element-769">
      <div className="main-container max-w-[1600px] mx-auto bg-card rounded-[1.5rem] md:rounded-[2rem] border border-black/5 shadow-sm min-h-[calc(100vh-2rem)] flex flex-col" data-id="element-770">
        <Navigation activePath="/typography" data-id="element-771" />

        <main className="flex-1 px-4 md:px-16 py-8 md:py-12 space-y-12 md:space-y-24" data-id="element-772">
          <section className="max-w-4xl" data-id="element-773">
            <div className="flex items-center gap-3" data-id="element-774">
              <div className="w-2 h-2 md:w-2.5 md:h-2.5 rounded-full bg-accent" data-id="element-775" />
              <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] font-medium text-muted-foreground" data-id="element-776">
                Visual Language
              </span>
            </div>
            <h1 className="mt-4 font-display text-3xl md:text-8xl tracking-[-0.04em] text-ink leading-tight" data-id="element-777">
              Typography
              <span className="text-accent inline-block w-2 md:w-3 h-2 md:h-3 rounded-full ml-2 mb-1" data-id="element-778" />
            </h1>
            <p className="mt-6 text-base md:text-lg leading-[1.7] text-ink/70 font-medium max-w-2xl" data-id="element-779">
              The brand utilises a clean, modern typographic system to
              communicate professionalism and accessibility.
            </p>
          </section>

          <section className="bg-white rounded-[0.75rem] md:rounded-[1.5rem] border border-black/5 overflow-hidden shadow-sm" data-id="element-780">
            <img src="https://cdn.magicpatterns.com/uploads/e5SVdWnc7DHWm1eRmYuG15/fonts.png" alt="Typography Style Guide" className="w-full h-auto block" loading="lazy" data-id="element-781" />
          </section>
        </main>

        <Footer data-id="element-782" />
      </div>
    </div>;
}